<template>
    <div class="shop-header-margin shop-header-element-ui-less"
         :class="'shop-header-element-ui-less-'+data_info.nav_color">
        <div class="top-one">
            <headall></headall>
            <!--      <div class="hidden-sm-and-down header_pc">-->
            <!--        <el-row class="head_dingbu">-->
            <!--          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">-->
            <!--            <div class="head_width">-->
            <!--              <span class="head_text">仪海仪家</span>-->
            <!--              &lt;!&ndash;              <img class="head_dingwei" src="../../../../assets/home/dingwei.png"/>&ndash;&gt;-->
            <!--              &lt;!&ndash;              <el-image v-if="data_info.nav_color==='theme_red'" :src="'../../../../assets/home/shops/wei_red.png'"></el-image>&ndash;&gt;-->
            <!--              <img class="head_dingwei" v-if="data_info.nav_color==='theme_blue'"-->
            <!--                   src="../../../../assets/home/dingwei.png"/>-->
            <!--              <img class="head_dingwei" v-if="data_info.nav_color==='theme_red'"-->
            <!--                   src="../../../../assets/home/shops/wei_red.png"/>-->
            <!--              <img class="head_dingwei" v-if="data_info.nav_color==='theme_orange'"-->
            <!--                   src="../../../../assets/home/shops/wei_or.png"/>-->
            <!--              <span-->
            <!--                      class="head_text head_text_cao_left">HI!{{-->
            <!--                  $store.state.information != '' ? $store.state.information.name : ''-->
            <!--                }}</span>-->
            <!--              <img class="head_youxiang" src="../../../../assets/home/xiaoxi.png"/>-->
            <!--              <a class="xuanzhong wenzi" href="">-->
            <!--              <span class="head_text head_text_xiaoxi_left">-->
            <!--                消息</span></a>-->
            <!--              <a class="xuanzhong wenzi youfudong" href="/user.html#/">-->
            <!--                <span class="head_text head_text_denglu_left">-->
            <!--                 {{ $store.state.information != '' ? '' : '登录/注册' }}</span></a>-->
            <!--&lt;!&ndash;                            <a class="xuanzhong wenzi youfudong" href="">&ndash;&gt;-->
            <!--&lt;!&ndash;                            <span class="head_text head_text_shouye_left">&ndash;&gt;-->
            <!--&lt;!&ndash;                              首页</span></a>&ndash;&gt;-->
            <!--&lt;!&ndash;                            <a class="xuanzhong wenzi youfudong" href="">&ndash;&gt;-->
            <!--&lt;!&ndash;                            <span class="hidden-md-and-down head_text head_text_wangzhan_left">&ndash;&gt;-->
            <!--&lt;!&ndash;                              网站导航</span></a>&ndash;&gt;-->
            <!--&lt;!&ndash;                            <a class="xuanzhong wenzi youfudong" href="">&ndash;&gt;-->
            <!--&lt;!&ndash;                            <span class="hidden-md-and-down head_text head_text_kefu_left">&ndash;&gt;-->
            <!--&lt;!&ndash;                              客服中心</span></a>&ndash;&gt;-->
            <!--&lt;!&ndash;                            <a class="xuanzhong wenzi youfudong" href="">&ndash;&gt;-->
            <!--&lt;!&ndash;                            <span class="head_text head_text_wode_left">&ndash;&gt;-->
            <!--&lt;!&ndash;                              我的收藏</span></a>&ndash;&gt;-->
            <!--&lt;!&ndash;                            <a class="xuanzhong wenzi youfudong" href="">&ndash;&gt;-->
            <!--&lt;!&ndash;                            <span class="head_text head_text_shangjia_left">&ndash;&gt;-->
            <!--              &lt;!&ndash;                商家工作台</span></a>&ndash;&gt;-->
            <!--               <div class="xixixi">-->
            <!--              <a class="xuanzhong wenzi youfudong" href="#/">-->
            <!--                            <span class="head_text head_text_shouye_left">-->
            <!--                                首页-->
            <!--                            </span>-->
            <!--              </a>-->
            <!--              <a class="xuanzhong wenzi youfudong" href="/user.html#/index">-->
            <!--                            <span class="head_text head_text_shangjia_left">-->
            <!--                                商家工作台-->
            <!--                            </span>-->
            <!--              </a>-->
            <!--              <a class="xuanzhong wenzi youfudong">-->
            <!--                <el-tooltip class="item" effect="dark" placement="bottom">-->
            <!--                  <div slot="content">-->
            <!--                    <span v-if="config.phone">电话：{{config.phone}}</span>-->
            <!--                    <br/>-->
            <!--                    <span v-if="config.email">邮箱：{{config.email}}</span>-->
            <!--                  </div>-->
            <!--                  <span class="hidden-md-and-down head_text head_text_kefu_left">-->
            <!--                                    客服中心-->
            <!--                                </span>-->
            <!--                </el-tooltip>-->

            <!--              </a>-->
            <!--              <a class="xuanzhong wenzi youfudong" href="user.html#/trans/collection" @click="Changeshuju()">-->
            <!--                            <span class="head_text head_text_wode_left">-->
            <!--                                我的收藏-->
            <!--                            </span>-->
            <!--              </a>-->
            <!--              <a class="xuanzhong wenzi youfudong" >-->
            <!--                <el-dropdown>-->
            <!--                                <span class="el-dropdown-link">-->
            <!--                                    <span class="hidden-md-and-down head_text head_text_wangzhan_left">-->
            <!--                                        网站导航-->
            <!--                                    </span>-->
            <!--                                    <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
            <!--                                </span>-->
            <!--                  <el-dropdown-menu slot="dropdown">-->
            <!--                    <el-dropdown-item>-->
            <!--                      <a class="top-right-link" href="#/">-->
            <!--                        首页-->
            <!--                      </a>-->
            <!--                    </el-dropdown-item>-->
            <!--                    <el-dropdown-item>-->
            <!--                      <a class="top-right-link" href="#/shop">-->
            <!--                        聚义商城-->
            <!--                      </a>-->
            <!--                    </el-dropdown-item>-->
            <!--                    <el-dropdown-item>-->
            <!--                      <a class="top-right-link" href="#/service/index">-->
            <!--                        服务直达-->
            <!--                      </a>-->
            <!--                    </el-dropdown-item>-->
            <!--                    <el-dropdown-item >-->
            <!--                      <a class="top-right-link" href="#/testing/index">-->
            <!--                        检验检测-->
            <!--                      </a>-->
            <!--                    </el-dropdown-item>-->
            <!--                    <el-dropdown-item >-->
            <!--                      <a class="top-right-link" href="#/general/index">-->
            <!--                        仪兵仪将-->
            <!--                      </a>-->
            <!--                    </el-dropdown-item>-->
            <!--                    <el-dropdown-item >-->
            <!--                      <a class="top-right-link" href="#/second_goods/index">-->
            <!--                        二手商品-->
            <!--                      </a>-->
            <!--                    </el-dropdown-item>-->
            <!--                    <el-dropdown-item >-->
            <!--                      <a class="top-right-link" href="#/college">-->
            <!--                        仪小星讲堂-->
            <!--                      </a>-->
            <!--                    </el-dropdown-item>-->
            <!--                  </el-dropdown-menu>-->
            <!--                </el-dropdown>-->
            <!--              </a>-->
            <!--            </div>-->
            <!--            </div>-->
            <!--          </el-col>-->

            <!--        </el-row>-->
            <!--      </div>-->
            <!--      <div class="hidden-sm-and-up header_phone">-->
            <!--        <span class="header_phone_name">仪海仪家</span>-->
            <!--        <img class="head_phone_dingwei" src="../../../../assets/home/dingwei.png"/>-->
            <!--        <span-->
            <!--                class="head_phone_huanyi">HI!{{-->
            <!--            $store.state.information != '' ? $store.state.information.name : '您好'-->
            <!--          }}</span>-->
            <!--        <img class="head_phone_xiaoxi_img" src="../../../../assets/home/xiaoxi.png"/>-->
            <!--        <span class="head_phone_xiaoxi">消息</span>-->
            <!--        <span class="head_phone_zhuce">{{ $store.state.information != '' ? '' : '[免费注册]' }}</span>-->
            <!--        <span class="head_phone_denglu">{{ $store.state.information != '' ? '' : '[登录]' }}</span>-->
            <!--      </div>-->
            <!--      height="218px"-->
            <!--      height="38px"-->
        </div>
        <div class="top-two hidden-sm-and-down">
            <el-row>
                <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                    <div>
                        <el-row :gutter="20">
                            <el-col :xs="14" :sm="9" :md="9" :lg="7" :xl="7">
                                <div>
                                    <img src="../../../../assets/home/logo.png" style="width: 100%;height: 100%"/>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                                <!-- <div>-->
                                <div class="top-two_text">
                                    <span style="float: left">{{data_info.shop_name }}</span>
                                    <!--nav_color-->
                                    <div class="follow" style="color: #c60000;border: 1px solid #c60000;">
                                        <span v-if="data_info.auth_info.type==1">个人</span>
                                        <span v-if="data_info.auth_info.type==2">企业</span>
                                        <span v-if="data_info.auth_info.type==3">企业</span>
                                    </div>
                                    <div class="follow" :class="data_info.nav_color+'_follow'"  @click="shouce()">
                                        {{xiontai}}
                                    </div>
                                </div>
                                <div class="label">技能标签：
                                    <el-tag type="info" style="margin-right: 5px;" size="mini"
                                            v-for="(item,index) in data_info.skill" :key="index">{{ item.tag_value }}
                                    </el-tag>
                                </div>
                                <!-- </div>-->
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="20" :md="9" :lg="9" :xl="9">
                    <div>
                        <el-input size="small " placeholder="请输入内容" v-model="input3" class="input-with-select">
                        <el-select class="xujz" v-model="select" slot="prepend" placeholder="请选择">
                            <el-option v-if="data_info.auth_info.type!==1" label="在线商品"
                            value="#/shops/commodity/"></el-option>
                            <el-option label="在线服务" value="#/shops/service/"></el-option>
                            <el-option label="成功案例" value="#/shops/case/"></el-option>
                            <el-option label="仪才秀" value="#/shops/video/"></el-option>
                            <el-option label="小星点灯" value="#/shops/light/"></el-option>
                            <el-option label="应用方案" value="#/shops/programme/"></el-option>
                            <el-option label="行业标准" value="#/shops/standard/"></el-option>
                        </el-select>
                        <el-button slot="append" @click="shijian">搜索</el-button>
                    </el-input>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="top-three hidden-sm-and-down" :class="data_info.nav_color">
            <div class="hidden-sm-and-down three_pc">
                <a :href="'#/shops/index/'+id">
                    <div class="kuai " :class="$route.path==='/shops/index/'+id?data_info.nav_color+'_new':''">首页</div>
                </a>
                <a :href="'#/shops/commodity/' + id">
                    <el-dropdown
                    class="kuai"
                    :class="
                        $route.path == '/shops/commodity/' + id
                        ? data_info.nav_color + '_new'
                        : ''
                    "
                    v-if="data_info.auth_info.type!==1"
                    >
                    <span class="el-dropdown-link">在线商品</span>

                    <el-dropdown-menu slot="dropdown" v-if="fuwu_list.length!=0" >
                        <a :href="'#/shops/commodity/' + id" style="text-decoration:none">
                            <el-dropdown-item
                            v-for="(shangpin, index) in shangpin_list"
                            :key="index"
                            >{{ shangpin.label }}</el-dropdown-item>
                        </a>
                    </el-dropdown-menu>
                    </el-dropdown>
                </a>
                <a :href="'#/shops/service/' + id">
                    <el-dropdown
                    class="kuai"
                    :class="
                        $route.path == '/shops/service/' + id
                        ? data_info.nav_color + '_new'
                        : ''
                    "
                    >
                    <span class="el-dropdown-link">在线服务</span>

                    <el-dropdown-menu slot="dropdown" v-if="fuwu_list.length!=0">
                        <a :href="'#/shops/service/' + id" style="text-decoration:none">
                            <el-dropdown-item
                            v-for="(fuwu, index) in fuwu_list"
                            :key="index"
                            >{{ fuwu.label }}</el-dropdown-item>
                        </a>
                        
                    </el-dropdown-menu>
                    </el-dropdown>
                </a>
                <a :href="'#/shops/case/'+id">
                    <div class="kuai" :class="$route.path=='/shops/case/'+id?data_info.nav_color+'_new':''">成功案例</div>
                </a>
                <a :href="'#/shops/video/'+id">
                    <div class="kuai" :class="$route.path=='/shops/video/'+id?data_info.nav_color+'_new':''">仪才秀</div>
                </a>
                <a :href="'#/shops/light/'+id">
                    <div class="kuai" :class="$route.path=='/shops/light/'+id?data_info.nav_color+'_new':''">小星点灯</div>
                </a>
                <a :href="'#/shops/programme/'+id">
                    <div class="kuai" :class="$route.path=='/shops/programme/'+id?data_info.nav_color+'_new':''">应用方案
                    </div>
                </a>
                <a :href="'#/shops/standard/'+id">
                    <div class="kuai" :class="$route.path=='/shops/standard/'+id?data_info.nav_color+'_new':''">行业标准
                    </div>
                </a>
                <a :href="'#/shops/companyData/'+id">
                    <div class="kuai" :class="$route.path=='/shops/companyData/'+id?data_info.nav_color+'_new':''">
                        公司资料
                    </div>
                </a>
                <a :href="'#/shops/bidding/'+id">
                    <div class="kuai" :class="$route.path=='/shops/bidding/'+id?data_info.nav_color+'_new':''">
                        求购信息
                    </div>
                </a>
            </div>
            <!--      <div class="hidden-sm-and-up three_phone">-->

            <!--      </div>-->
        </div>
    </div>
</template>
<script>
    import headall from "../../../../components/common/head"

    export default {
        name: 'App',

        props: {
            'dzhi': {
                default: ''
            }
        },

        components: {
            headall
        },
        data: function () {
            return {
                is_open: {
                    sousuo: 1,
                    lanmu: 1,
                    phone_shaixuan: 0,
                    phone_sousuokuang: 0,
                    color: '',
                },
                information: '',
                input3: '',
                select: '在线服务',
                status: '',
                id: '',
                data_info: '',
                xiontai: '',
                onpen_is:'',
                config: {
                    email: '',
                    phone: '',
                },
                shangpin_list:'',
                fuwu_list:''
            }
        },
        methods: {
            Changeshuju() {
                this.$store.commit('Changestate');
            },
            getConfig: function () {

                var t = this;
                // this.config.email = localStorage.getItem('site:email');
                // this.config.phone = localStorage.getItem('site:service-phone');
                if (!this.config.email || !this.config.phone) {
                    let url = window.config.api_url + '/user/config/site'
                    this.axios.get(url).then(res => {

                        t.config.email = res.data.site.email;
                        t.config.phone = res.data.site['service-phone'];
                        // localStorage.setItem('site:email', t.config.email);
                        // localStorage.setItem('site:service-phone', t.config.phone);
                    });

                }
            },
            sousuo_xuanxiang(e) {
                this.is_open.sousuo = e
                // console.log(this.is_open.sousuo)
            },
            init() {

                this.information = this.$store.state.information
                // console.log(12345)
                this.id = this.$route.params.id
                // console.log(this.id)
                this.list_info()
                this.zhuangtai()


            },
            zhuangtai() {
                var t = this
                var id = localStorage.getItem('token')
                var url = window.config.api_url + '/user/shop/focus/check/' + t.$route.params.id + '?token=' + id
                t.axios.get(url).then(res => {
                    // console.log(res,89444444444)
                    t.xiontai = res.data.focus == 1 ? '已关注' : '关注'
                })
            },
            shouce() {
                // console.log(cet);
                var t = this
                var id = localStorage.getItem("uid")
                var formData = new FormData();
                formData.append('token', id);
                formData.append('shop_id', this.$route.params.id);
                if (t.xiontai == '关注') {
                    var url = window.config.api_url + '/user/shop/focus'
                    t.axios.post(url, formData).then(res => {
                        // console.log(res)
                        t.$code(res.data.status)
                        if (res.data.status == 0) {
                            t.open2('成功')
                            // t.list_data()
                            this.$router.go(0);
                        }
                        if (res.data.status != 0) {
                            t.open3(res.data.description)
                        }
                    })
                    this.xiontai = '已关注'
                } else {
                    var url1 = window.config.api_url + '/user/shop/unfocus'
                    t.axios.post(url1, formData).then(res => {
                        // console.log(res)
                        t.$code(res.data.status)
                        if (res.data.status == 0) {
                            t.open2('成功')
                            // t.list_data()
                            this.$router.go(0);
                        }
                        if (res.data.status != 0) {
                            t.open3(res.data.description)
                        }
                    })
                    this.xiontai = '关注'
                }
            },
            list_info() {
                var t = this
                var url = window.config.api_url + '/college/shop/info?id=' + this.$route.params.id
                // if(this.dzhi!=''){
                //     var url1 = window.config.api_url + '/college/shop/info?id=' + this.dzhi
                // }
                t.axios.get(url).then(res => {
                    t.data_info = res.data
                    console.log("展示1213121", res.data)
                })
            },
            shijian() {
                var t = this
                if (t.input3) {
                    t.$store.commit('shopsSearchValue', t.input3)
                }
                window.location = t.select + this.$route.params.id
            },
            shangpin_data(){
                var t = this
                var url = window.config.api_url+'/college/shop/goods/cate?shop_id='+t.id
                t.axios.get(url).then(res=>{
                    if (res.data.status){
                    t.$code(res.data.status)
                    }
                    if (res.data.status==401){
                    t.opent()
                    }
                    t.shangpin_list = res.data
                    console.log("sangpin_list",res.data)
                    // t.zongshu = res.data.goods_list.total
                    // t.yemashu =  res.data.goods_list.last_page
                    // console.log(res)
                })
            },
            fuwu_data(){
            var t = this
            var url = window.config.api_url+'/college/shop/fuwu/cate?shop_id='+t.id
            t.axios.get(url).then(res=>{
                if (res.data.status){
                t.$code(res.data.status)
                }
                if (res.data.status==401){
                t.opent()
                }
                t.fuwu_list = res.data
                console.log("fuwu_list",res.data)
                // t.zongshu = res.data.goods_list.total
                // t.yemashu =  res.data.goods_list.last_page
                // console.log(res)
            })
            
            },
        },
        created() {
            this.init();
            this.getConfig()
            this.shangpin_data()
            this.fuwu_data()
            
        }
    }


</script>
<style lang="less">
    .shop-header-margin {
        width: 100%;
        .head_text {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 550;
            color: #333333;
            line-height: 38px;
        }

        .top-one {
            width: 100%;
            height: 38px;
            background: #F4F4F4;

            .header_pc {
                margin: 0 auto !important;
                max-width: 1200px;
                width: 90%;

                .head_dingbu {
                    width: 100%;
                    height: 38px;
                    background: #F4F4F4;

                    .head_width {
                        width: 100%;
                        max-width: 1200px;
                        margin-right: auto;
                        margin-left: auto;

                        .head_dingwei {
                            //float: ;
                            margin-left: 5px;
                            margin-top: 13px;
                            position: absolute;
                            width: 10px;
                            height: 13px;
                        }

                        .head_youxiang {
                            margin-left: 34px;
                            margin-top: 13px;
                            position: absolute;
                            width: 17px;
                            height: 13px;
                        }

                        .head_text_cao_left {
                            margin-left: 26px;
                        }

                        .head_text_xiaoxi_left {
                            margin-left: 57px;
                        }

                        .head_text_denglu_left {
                            margin-left: 202px;
                        }

                        .head_text_shouye_left {
                            margin-left: 48px;
                        }

                        .head_text_shangjia_left {
                            margin-left: 44px;
                        }

                        .head_text_wode_left {
                            margin-left: 46px;
                        }

                        .head_text_kefu_left {
                            margin-left: 50px;
                        }

                        .head_text_wangzhan_left {
                            margin-left: 34px;
                        }

                        .header_logo_top {
                            margin-top: 32px;

                            .header_logo {
                                width: 181px;
                                height: 48px;
                                float: left;
                            }

                            .header_sousuo {

                                width: 503px;
                                height: 45px;
                                margin-top: 20px;
                                border: 3px solid #4E6EF2;
                                border-radius: 5px 0px 0px 5px;
                                //margin-left: 20%;
                                float: left;

                                .header_sousuo_logo {
                                    width: 14px;
                                    height: 14px;
                                    margin-top: 16px;
                                    margin-left: 13px;
                                    margin-right: 15px;
                                    float: left;
                                }

                                .header_sousuo_tuijian {
                                    position: absolute;
                                    margin-top: -22px;
                                    font-size: 14px;
                                    font-family: Source Han Sans CN;
                                    font-weight: bold;
                                    color: #333333;
                                    float: left;
                                    margin-left: 45px;
                                }

                                .header_sousuo_tuijian_2 {
                                    margin-left: 125px;
                                }

                                .header_sousuo_tuijian_3 {
                                    margin-left: 205px;
                                }

                                .header_sousuo_tuijian_xuanzhong {
                                    padding: 5px 10px 1px 10px;
                                    background: #4E6EF2;
                                    margin-top: -29px;
                                    color: #FFFFFF;
                                    border-radius: 5px 5px 0px 0px;
                                }
                            }

                            .header_sousuo_button {
                                margin-top: 20px;
                                border: none;
                                width: 100px;
                                height: 45px;
                                background: #4E6EF2;
                                border-radius: 0px 5px 5px 0px;

                                font-size: 18px;
                                font-family: Source Han Sans CN;
                                font-weight: bold;
                                color: #FFFFFF;
                            }
                        }

                        .header_gongye_lianjie {
                            margin-top: 36px;

                            .header_gongye_kuang {
                                float: left;
                                width: 220px;
                                height: 45px;
                                background: #4E6EF2;
                                border-radius: 5px 5px 0px 0px;

                                .header_gongye_kuang_text {
                                    //width: 74px;
                                    //height: 18px;
                                    cursor: pointer;
                                    float: left;
                                    font-size: 18px;
                                    font-family: Source Han Sans CN;
                                    font-weight: 400;
                                    color: #FFFFFF;
                                    margin-top: 10px;
                                    margin-left: 22px;
                                    //line-height: 100px;
                                }

                                .header_gongye_kuang_zhuangtai {
                                    width: 40px;

                                    background: #FFFFFF;
                                    border-radius: 2px;
                                    float: left;
                                    margin-top: -2px;
                                    margin-left: 36px;
                                }

                                .header_gongye_kuang_zhuangtai2 {
                                    width: 40px;
                                    height: 3px;
                                    background: #FFFFFF;
                                    border-radius: 2px;
                                    float: left;
                                    margin-top: -2px;
                                    margin-left: 130px;
                                }
                            }

                            .header_gongye_lianjie_qiota {
                                float: left;
                                margin-left: 50px;
                                font-size: 18px;
                                font-family: Source Han Sans CN;
                                font-weight: bold;
                                color: #333333;
                                margin-top: 8px;
                                //line-height: 100px;
                            }

                            .header_gongye_lianjie_qiota_xuanzhong {
                                font-size: 22px;
                                //font-weight: bold;
                                color: #4E6EF2;
                                margin-top: 4px;
                                //line-height: 100px;
                            }
                        }
                    }
                }
            }

            .header_phone {
                background: #f4f4f4;
                color: #333333;
                line-height: 38px;
                font-size: 12px;
                padding-right: 15px;
                padding-left: 15px;
                font-family: Source Han Sans CN;
                font-weight: 600;

                .header_phone_name {
                    float: left;
                }

                .head_phone_dingwei {
                    float: left;
                    width: 10px;
                    margin-top: 12px;
                    margin-left: 5px;
                }

                .head_phone_huanyi {
                    float: left;
                    margin-left: 12px;
                }

                .head_phone_xiaoxi_img {
                    float: left;
                    width: 18px;
                    margin-top: 12px;
                    margin-left: 20px;
                }

                .head_phone_xiaoxi {
                    float: left;
                    margin-left: 5px;
                }

                .head_phone_denglu {
                    float: right;
                    margin-right: 7px;
                }

                .head_phone_zhuce {
                    float: right;
                }
            }

        }

        .top-two {
            margin: 36px auto !important;
            max-width: 1200px;
            width: 90%;

            .top-two_text {
                //width: 222px;
                //height: 27px;
                font-size: 20px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #333333;
                //float: left;
                .follow {
                    margin-left: 10px;
                    margin-top: 5px;
                    float: left;
                    width: 45px;
                    height: 20px;
                    border: 1px solid #4E6EF2;
                    border-radius: 5px;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    color: #4E6EF2;
                    line-height: 20px;
                    text-align: center;
                }

                .theme_blue_follow {
                    color: #4E6EF2;
                    border: 1px solid #4E6EF2;
                }

                .theme_red_follow {
                    //background:#ed3a3d;
                    color: #ed3a3d;
                    border: 1px solid #ed3a3d;
                }

                .theme_orange_follow {
                    //background:#e86419;
                    color: #e86419;
                    border: 1px solid #e86419;

                }
            }

            .label {
                float: left;
                width: 100%;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #333333;
                line-height: 25px;
            }
        }

        .top-three {
            width: 100%;
            height: 55px;
            background: #4E6EF2;

            .three_pc {
                margin: 0 auto !important;
                max-width: 1200px;
                width: 90%;

                .kuai {
                    float: left;
                    text-align: center;
                    // width: 11%;
                    width: 9.7%;
                    height: 55px;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 55px;
                }

                .new {
                    width: 12%;
                    font-size: 20px;
                    background: linear-gradient(180deg, #738AEA 0%, rgba(115, 138, 234, 0) 100%);
                }

                .theme_blue_new {
                    width: 12%;
                    font-size: 20px;
                    background: linear-gradient(180deg, #738AEA 0%, rgba(115, 138, 234, 0) 100%);
                }

                .theme_red_new {
                    width: 12%;
                    font-size: 20px;
                    background: linear-gradient(180deg, #ef6668 0%, rgba(115, 138, 234, 0) 100%);
                }

                .theme_orange_new {
                    width: 12%;
                    font-size: 20px;
                    background: linear-gradient(180deg, #e09f7a 0%, rgba(115, 138, 234, 0) 100%);
                }
            }

            .three_phone {

            }
        }

        .theme_blue {
            background: #4E6EF2;
        }

        .theme_red {
            background: #ed3a3d;
        }

        .theme_orange {
            background: #e86419;
        }
    }
</style>
<style lang="less">
    .shop-header-element-ui-less {
        .el-select .el-input {
            width: 100px;
        }

        .el-input__inner {
            border-top: 1px solid #4E6EF2;
            border-bottom: 1px solid #4E6EF2;
            border-left: none;
            border-right: none;
        }

        .input-with-select .el-input-group__prepend {
            background-color: #fff;
        }

        .el-input-group__append, .el-input-group__prepend {
            background-color: #4E6EF2;
            color: #FFFFFF;
            border: 1px solid #4E6EF2;
        }

        .xujz {
            .el-input__inner {
                color: #333333 !important;
            }
        }

        .el-input.is-active .el-input__inner, .el-input__inner:focus {
            border-color: #4E6EF2;
        }

        .el-input--small .el-input__inner {
            height: 46px;
        }
    }

    .shop-header-element-ui-less-theme_blue {
        .el-select .el-input {
            width: 100px;
        }

        .el-input__inner {
            border-top: 1px solid #4E6EF2;
            border-bottom: 1px solid #4E6EF2;
            border-left: none;
            border-right: none;
        }

        .input-with-select .el-input-group__prepend {
            background-color: #fff;
        }

        .el-input-group__append, .el-input-group__prepend {
            background-color: #4E6EF2;
            color: #FFFFFF;
            border: 1px solid #4E6EF2;
        }

        .xujz {
            .el-input__inner {
                color: #333333 !important;
            }
        }

        .el-input.is-active .el-input__inner, .el-input__inner:focus {
            border-color: #4E6EF2;
        }

        .el-input--small .el-input__inner {
            height: 46px;
        }
    }

    .shop-header-element-ui-less-theme_red {
        .el-select .el-input {
            width: 100px;
        }

        .el-input__inner {
            border-top: 1px solid #ed3a3d;
            border-bottom: 1px solid #ed3a3d;
            border-left: none;
            border-right: none;
        }

        .input-with-select .el-input-group__prepend {
            background-color: #fff;
        }

        .el-input-group__append, .el-input-group__prepend {
            background-color: #ed3a3d;
            color: #FFFFFF;
            border: 1px solid #ed3a3d;
        }

        .xujz {
            .el-input__inner {
                color: #333333 !important;
            }
        }

        .el-input.is-active .el-input__inner, .el-input__inner:focus {
            border-color: #ed3a3d;
        }

        .el-input--small .el-input__inner {
            height: 46px;
        }
    }

    .shop-header-element-ui-less-theme_orange {
        .el-select .el-input {
            width: 100px;
        }

        .el-input__inner {
            border-top: 1px solid #e86419;
            border-bottom: 1px solid #e86419;
            border-left: none;
            border-right: none;
        }

        .input-with-select .el-input-group__prepend {
            background-color: #fff;
        }

        .el-input-group__append, .el-input-group__prepend {
            background-color: #e86419;
            color: #FFFFFF;
            border: 1px solid #e86419;
        }

        .xujz {
            .el-input__inner {
                color: #333333 !important;
            }
        }

        .el-input.is-active .el-input__inner, .el-input__inner:focus {
            border-color: #e86419;
        }

        .el-input--small .el-input__inner {
            height: 46px;
        }
    }

    .xixixi {
        display: inline-block;
        position: absolute;
        right: 0;
    }

    /*.head_dingwei{*/
    /*  width: 10px;*/
    /*  height: 13px;*/
    /*}*/
    /*.head_youxiang{*/
    /*  */
    /*}*/
</style>